import { CheckCheck, X } from 'lucide-react';

interface Props {
  selectedCount: number;
  onBulkApprove: () => void;
  onClearSelection: () => void;
  busy?: boolean;
}

// 권위: ARCH_DASHBOARD §4.10 하단 일괄 처리 툴바.
export function PendingCABulkActions({
  selectedCount,
  onBulkApprove,
  onClearSelection,
  busy,
}: Props): JSX.Element {
  return (
    <div className="pca-bulk">
      <span className="pca-bulk__count">선택: {selectedCount} 건</span>
      <button
        type="button"
        className="pca-btn pca-btn--primary"
        disabled={selectedCount === 0 || busy}
        onClick={onBulkApprove}
      >
        <CheckCheck size={14} strokeWidth={1.75} />
        선택 일괄 승인
      </button>
      <button
        type="button"
        className="pca-btn pca-btn--ghost"
        disabled={selectedCount === 0 || busy}
        onClick={onClearSelection}
      >
        <X size={14} strokeWidth={1.75} />
        선택 해제
      </button>
      <span style={{ flex: 1 }} />
      <span className="pca-muted">
        ※ 안전 상한 500 건. 개별 트랜잭션으로 처리되며 일부 실패 가능.
      </span>
    </div>
  );
}
